import APP_SETTINGS from "./settings.json";

export const fetchMockAppSettings = async () => {
    return Promise.resolve(APP_SETTINGS.DNP);
};

export const fetchMockDirectoryConfig = async () => {
    return Promise.resolve(APP_SETTINGS.DIRECTORY_CONFIG);
};